// Global JavaScript for Dogonit H2O Shopify theme

document.addEventListener('DOMContentLoaded', function() {

  // Initialize theme

  initializeTheme();

});

function initializeTheme() {

  // Initialize cart functionality

  initializeCart();

  

  // Initialize product forms

  initializeProductForms();

  

  // Initialize mobile menu

  initializeMobileMenu();

  

  // Initialize smooth scroll

  initializeSmoothScroll();

}

// Cart functionality

function initializeCart() {

  // Add to cart forms

  document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {

    form.addEventListener('submit', handleAddToCart);

  });

  // Update cart count

  updateCartCount();

}

async function handleAddToCart(event) {

  event.preventDefault();

  const form = event.target;
  const submitButton = form.querySelector('[type="submit"]');
  const originalButtonText = submitButton ? submitButton.textContent : '';

  try {

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.dataset.originalText = originalButtonText;
      submitButton.textContent = submitButton.dataset.loadingText || 'Adding...';
    }

    const response = await fetch('/cart/add.js', {

      method: 'POST',

      body: new FormData(form)

    });

    

    if (response.ok) {

      await response.json();

      

      // Update count first

      await updateCartCount();

      

      // Then open drawer (it will fetch fresh data)

      await openCartDrawer();

    }

  } catch (error) {

    console.error('Error adding to cart:', error);

  } finally {

    if (submitButton) {
      submitButton.disabled = false;
      submitButton.textContent = submitButton.dataset.originalText || originalButtonText || submitButton.textContent;
    }

  }

}

async function updateCartCount() {

  try {

    const response = await fetch('/cart.js');

    const cart = await response.json();

    

    document.querySelectorAll('[data-cart-count]').forEach(element => {

      element.textContent = cart.item_count;

    });

    return cart.item_count;

  } catch (error) {

    console.error('Error updating cart count:', error);

  }

  return null;

}

async function openCartDrawer() {

  const cartDrawer = document.querySelector('[data-cart-drawer]');

  if (cartDrawer && typeof cartDrawer.open === 'function') {

    await cartDrawer.open();

  }

}

// Product forms

function initializeProductForms() {

  // Variant selectors

  document.querySelectorAll('[data-variant-select]').forEach(select => {

    select.addEventListener('change', handleVariantChange);

  });

}

function handleVariantChange(event) {

  const form = event.target.closest('form');

  const selectedOptions = [];

  

  form.querySelectorAll('[data-variant-select]').forEach(select => {

    selectedOptions.push(select.value);

  });

  

  // Find matching variant

  const variants = JSON.parse(form.dataset.variants || '[]');

  const variant = variants.find(v => {

    return v.options.every((option, index) => option === selectedOptions[index]);

  });

  

  if (variant) {

    // Update variant input

    const variantInput = form.querySelector('[name="id"]');

    if (variantInput) {

      variantInput.value = variant.id;

    }

    

    // Update price

    const priceElement = form.querySelector('[data-product-price]');

    if (priceElement) {

      priceElement.textContent = formatMoney(variant.price);

    }

    

    // Update button state

    const submitButton = form.querySelector('[type="submit"]');

    if (submitButton) {

      if (variant.available) {

        submitButton.disabled = false;

        submitButton.textContent = submitButton.dataset.addToCartText || 'Add to cart';

      } else {

        submitButton.disabled = true;

        submitButton.textContent = submitButton.dataset.soldOutText || 'Sold out';

      }

    }

  }

}

// Mobile menu

function initializeMobileMenu() {

  const menuToggle = document.querySelector('[data-mobile-menu-toggle]');

  const mobileMenu = document.querySelector('[data-mobile-menu]');

  

  if (menuToggle && mobileMenu) {

    menuToggle.addEventListener('click', () => {

      mobileMenu.classList.toggle('is-active');

      document.body.classList.toggle('menu-open');

    });

    

    // Close menu when clicking outside

    document.addEventListener('click', (event) => {

      if (!menuToggle.contains(event.target) && !mobileMenu.contains(event.target)) {

        mobileMenu.classList.remove('is-active');

        document.body.classList.remove('menu-open');

      }

    });

  }

}

// Smooth scroll

function initializeSmoothScroll() {

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {

    anchor.addEventListener('click', function(event) {

      event.preventDefault();

      const target = document.querySelector(this.getAttribute('href'));

      

      if (target) {

        target.scrollIntoView({

          behavior: 'smooth',

          block: 'start'

        });

      }

    });

  });

}

// Money formatting

function formatMoney(cents, format = '${{amount}}') {

  const value = (cents / 100).toFixed(2);

  return format.replace('{{amount}}', value);

}

// Debounce function

function debounce(func, wait) {

  let timeout;

  return function executedFunction(...args) {

    const later = () => {

      clearTimeout(timeout);

      func(...args);

    };

    clearTimeout(timeout);

    timeout = setTimeout(later, wait);

  };

}

// Throttle function

function throttle(func, limit) {

  let inThrottle;

  return function(...args) {

    if (!inThrottle) {

      func.apply(this, args);

      inThrottle = true;

      setTimeout(() => inThrottle = false, limit);

    }

  };

}

// Export utilities for use in other scripts

window.theme = window.theme || {};

window.theme.cart = {

  updateCount: updateCartCount,

  open: openCartDrawer

};

window.theme.utils = {

  debounce,

  throttle,

  formatMoney

};